import Breadcrumb, { type BreadcrumbItem } from "@/components/base/Breadcrumb";

interface PageHeroProps {
  title: string;
  subtitle: string;
  icon: string;
  breadcrumb: BreadcrumbItem[];
  meta?: string;
}

export default function PageHero({ title, subtitle, icon, breadcrumb, meta }: PageHeroProps) {
  return (
    <section className="w-full bg-gradient-to-r from-primary-700 via-primary-600 to-primary-500">
      <div className="mx-auto max-w-7xl px-4 py-8 md:px-8 md:py-12">
        <Breadcrumb items={breadcrumb} variant="light" />
        <div className="mt-5 flex items-start gap-4">
          <span className="hidden h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-background-50/15 text-background-50 sm:flex">
            <i className={`${icon} text-2xl`} />
          </span>
          <div>
            <h1 className="font-heading text-2xl font-bold tracking-tight text-background-50 md:text-3xl">
              {title}
            </h1>
            <p className="mt-2 max-w-3xl text-sm leading-relaxed text-background-200 md:text-base">{subtitle}</p>
            {meta && <p className="mt-3 text-xs font-medium text-accent-300">{meta}</p>}
          </div>
        </div>
      </div>
    </section>
  );
}